/**
 * H5Notify  消息提示- hansin
 * @param {Object} option
 * @param {String} option.closeH5Notice 关闭h5提示, 只使用ele提示
 * @param {String} option.title
 * @param {String} option.htmlMessage
 * @param {String} option.message
 * @param {Number} option.duration
 * @param {Function} option.handClick
 * @param {String} option.tag
 * @param {Object} option.data
 * @param {String} option.icon
 * @param {String} option.image
 */

import Vue from 'vue'
const vm = new Vue()

const H5Notify = (option) => {
  if (!('Notification' in window) || option.closeH5Notice) { // 不支持Notification
    H5Notify.elNotify(option)
  } else {
    Notification.requestPermission().then((permission) => {
      if (permission === 'granted') { // 用户允许通知
        let n = new Notification(option.title || '提示', {
          body: option.message,
          tag: option.tag || 'h5notify',
          data: option.data,
          renotify: option.renotify || true,
          icon: option.icon || null, // 要在通知中显示的图标的URL
          image: option.image || null, // 要在通知中显示的图像的URL
          requireInteraction: true
        })

        // 点击事件
        n.onclick = () => {
          let backData = Object.assign({open: 1}, n.data)
          option.handClick && option.handClick(backData)
          // if (n.data.url) {
          //   window.open(n.data.url, '_blank') // 打开网址
          // }
          n.close()
        }

        // 定时关闭
        if (option.duration) {
          setTimeout(() => {
            n.close()
          }, option.duration)
        }
      } else {
        H5Notify.elNotify(option)
      }
    })
  }
}

H5Notify.elNotify = (option) => {
  let n = vm.$notify({
    customClass: 'h5-notify',
    iconClass: option.iconClass || '',
    title: option.title || '提示',
    dangerouslyUseHTMLString: !!option.htmlMessage,
    message: option.htmlMessage || option.message,
    offset: 42,
    duration: option.duration || 0,
    onClick: () => {
      n.close()
      option.handClick && option.handClick(option.data)
    }
  })
}

Vue.prototype.$h5notify = H5Notify

export const h5NotifyObj = {
  htmlStr (str) {
    return `<span style='display:inline-block;overflow: hidden;word-wrap: normal;white-space: nowrap;text-overflow: ellipsis;max-width:217px;'>${str}</span><span style="position: absolute;color: #407CFE;text-decoration:underline;cursor:pointer;white-space:nowrap;">点击查看</span>`
  }
  // h5NotifyFn (obj) {
  //   this.$h5notify({
  //     closeH5Notice: false,
  //     title: obj.title,
  //     iconClass: `icon-font ${obj.iconClass}`,
  //     htmlMessage: obj.htmlMessage,
  //     message: obj.message,
  //     tag: 'email' + (+new Date()),
  //     duration: 8000,
  //     // icon: 'http://blog.gdfengshuo.com/images/avatar.jpg', // 要在通知中显示的图标的URL
  //     handClick: (data) => {
  //       console.log(data)
  //       if (data.open) {
  //         window.open(window.location.origin + '/#/mail/list' + '?accountId=' + data.accountId, '_blank')
  //       } else {
  //         // 跳到对应的账号
  //         this.$store.commit('CHANGE_CURRENT_MAILINDEX', obj.mailKey)
  //         obj.callback && obj.callback()
  //       }
  //     },
  //     data: {
  //       accountId: obj.accountId,
  //       url: window.location.origin + '/#/mail/list'
  //     }
  //   })
  // }
}

const Tionencryp = {
  tionencrypStr () {
    let a = 'MzEzMjMzMzczODM5MzAzNDM1MzY0M'
    let b = 'DU0NzQ5NGIzNDM1MzYzNzMxMzIzMzM4MzkzMDQ0NDU0NjQxNDI0Mw=='
    return [a, b]
  }
}

export default Tionencryp
